<script>
	  import { user, view, send_data } from "../client.svelte.js";
    import {calc_defaultCS, exhibit_URL, mapimg_URL} from "../core.js"
	  import { flip } from "svelte/animate";
	  import {sections_of, site_of, particips_of, sectTyp, sectTag} from "./_Prepare.svelte";
	  import Sidebar, {open_flyout_next} from "../elements/Sidebar.svelte";

	  const animDuration = 300

	  let newOrdering = $state(null)		// section IDs in their order while a section is dragged
	  let sections = $derived((newOrdering ? newOrdering : view.adventure.sections).map(sectID => user.sections.get(sectID)).filter(Boolean))
	  let draggedSection = null
	  let swapping = new Set()
	  let prevOrdering = null
	  let exhibits = $derived(
		  Object.groupBy(
			  user.exhibits.values()
				.filter(img => img.advtID === view.adventure?.ID)
				.toArray()
			, (img) => img.sectID) )

	  // $inspect("STRUCTURE - exhibits", exhibits)


    function select_section(sectID) {
        view.select_section(sectID)
        view.switch_layout('advt-section')
		}

		function pickup_section(e) {
				e.stopPropagation()
				draggedSection = this
				prevOrdering = sections.map(sect => sect.ID)
				newOrdering = Array.from(prevOrdering)
        view.dragParams = {typ: 'sect', ID: this.ID, startY: e.clientY}
        e.dataTransfer.setData('sect/ID', this.ID)
        e.dataTransfer.effectAllowed = 'move'
        e.dataTransfer.setDragImage(e.currentTarget, 25, 25)
		}

		function dragging_section(e) {
				if (!draggedSection)  return		// dragging other things (sites, characters) over the table
				e.stopPropagation()
        e.preventDefault()
				const dir = (e.clientY < view.dragParams.startY) ? -1 : +1
				if (swapping.has(this) || Object.is(this, draggedSection) || (e.offsetY * dir < e.currentTarget.clientHeight / 2 * dir))
						return
        e.dataTransfer.dropEffect = 'move'
				console.log(`STRUCTURE - exchanging ${this.ID} with ${draggedSection.ID}`)
				swapping.add(this)
				// move the dragged section to the place of this section (other sections shift by one)
				const fromIdx = newOrdering.indexOf(draggedSection.ID)
				const toIdx = newOrdering.indexOf(this.ID)
				if (fromIdx < 0 || toIdx < 0 || (toIdx - fromIdx) * dir < 0)		// only move in dragging direction
						return swapping.delete(this)
				newOrdering.splice(fromIdx, 1)
				newOrdering.splice(toIdx, 0, draggedSection.ID)
				view.dragParams.startY = e.clientY
				setTimeout(() => swapping.delete(this), animDuration)
		}

		function drop_section(e) {
				if (!prevOrdering)  return
				const ordering = $state.snapshot(newOrdering)
				if (ordering.some((sectID, idx) => sectID !== prevOrdering[idx])) {
						console.log(`STRUCTURE - new ordering`, ordering)
						view.adventure.sections = ordering		// show new order until server update arrives
						send_data(`/adventure/${view.adventure.ID}`, {sections: ordering}, 'PATCH')
				}
				newOrdering = null
				prevOrdering = null
				draggedSection = null
		}

		function add_section(type) {
				send_data('/section/_', {type: type})
		}

		/** opens the site of a scene (or the section with the map selection if no site is chosen yet) **/
		async function select_site(e, sect) {
				e.stopPropagation()
				view.select_section(sect.ID)
				const site = site_of(sect)
				if (site) {
					await view.select_site(site.ID)
					view.switch_layout('advt-siteDetails')
				} else {
					open_flyout_next('sitepick')
					view.switch_layout('advt-section')
				}
    }

		async function select_character(e, sect, char) {
				e.stopPropagation()
				view.select_section(sect.ID)
				await view.select_character(char.ID)
				view.switch_layout('advt-charDetails')
    }

	function over_dropzone(e) {
		if (draggedSection)  return
		e.preventDefault()
        e.dataTransfer.dropEffect = "move"
    }

	function drop_particip(e, sect) {
		e.preventDefault()
        const charID = e.dataTransfer.getData("char/ID")
        if (!charID)  return
        const character = user.characters.get(charID)
        const charCS = calc_defaultCS(character.name, character.isIndividuum)
        console.log(`Dropping participant ${charID} into section ${sect.ID}`)
        send_data(`/deploy/_`, {sectID: sect.SECT, callsign: charCS, charID: charID})
    }

    function drop_locale(e, sect) {
        e.preventDefault()
        const siteID = e.dataTransfer.getData("site/ID")
        if (!siteID || sect.ZUB !== 'Scene')  return
        console.log(`Dropping site ${siteID} into scene ${sect.ID}`)
        send_data(`/section/${sect.ID}`, {siteID: siteID}, 'PATCH')
	}

    async function delete_section() {
        window.alert("Um einen Abschnitt zu löschen, zieh ihn einfach auf diesesn Knopf")
    }

</script>


<!-------------------------------- HTML -------------------------------------->

<section id={view.layout.page}>
	<Sidebar items={[
		{id: 'scene', icon: 'plus', label: "Szene", title: "Szene hinzufügen", primary: true, onclick: () => add_section('Scene')},
		{id: 'story', icon: 'plus', label: "Story", title: "Story hinzufügen", primary: true, onclick: () => add_section('Story')},
		{id: 'journey', icon: 'plus', label: "Reise", title: "Reise hinzufügen", primary: true, onclick: () => add_section('Journey')},
		{id: 'delete', icon: 'trash', label: "Löschen", title: "Abschnitt löschen", onclick: delete_section} ]}/>

	<article class="page">
		<table class="dataTable sections">
			<thead>
				<tr>
					<th class="grip"></th>
					<th class="num">#</th>
					<th class="typ">Typ</th>
					<th>Name</th>
					<th class="site">Karte</th>
					<th class="npcs">Antagonisten</th>
					<th class="images">Bilder</th>
				</tr>
			</thead>
			<tbody>
				{#each sections as sect, idx (sect.ID)}
					{@const site = site_of(sect)}
					<tr animate:flip={{duration: animDuration}} draggable=true title={sect.ID}
					    ondragstartcapture={pickup_section.bind(sect)} ondragovercapture={dragging_section.bind(sect)} ondragend={drop_section}
					    onclick={() => select_section(sect.ID)}>
						<td class="grip" data-help="order" title="ziehen, um die Reihenfolge zu ändern"><i class="fa icon-grip-vertical"></i></td>
						<td class="num">{idx + 1}</td>
						<td class="typ"><span class="tag {sectTag[sect.ZUB]}" class:started={!!sect.started}>{sectTyp[sect.ZUB]}</span></td>
						<td class="name">{sect.name}</td>
						<!---- Map or Site ---->
						<td class="site" data-help="site" ondrop={(e) => drop_locale(e, sect)} ondragover={over_dropzone}>
							{#if site}
								<button class="siteLink" title="Ort bearbeiten" onclick={(e) => select_site(e, sect)}>
									<img src={mapimg_URL(site)} alt={site.ID}>
									<span>{site.name}</span>
								</button>
							{:else if sect.ZUB === 'Scene'}
								<button class="textBtn" onclick={(e) => select_site(e, sect)}><i class="fa icon-plus"></i>Karte wählen</button>
							{/if}
						</td>
						<!---- Participants ---->
						<td class="npcs" data-help="npcs" ondrop={(e) => drop_particip(e, sect)} ondragover={over_dropzone}>
							<div class="tokens">
								{#each particips_of(view.adventure, sect.SECT) as partaker (partaker.ID)}
									<button class="tokenBtn" title={partaker.name} onclick={(e) => select_character(e, sect, partaker)}>
										<img class="token" src={partaker.tokenURL} alt={partaker.CS ?? partaker.ID}>
									</button>
								{/each}
							</div>
						</td>
						<!---- Images ---->
						<td class="images" data-help="exhibits">
							<div class="thumbs">
								{#each exhibits[sect.SECT] ?? [] as exhibit (exhibit.ID)}
									<button class="thumbBtn" title={exhibit.title} onclick={(e) => {e.stopPropagation(); view.exhibit = exhibit}}>
										<img class="thumb" class:exhibited={game.exhibits.includes(exhibit.ID)} src={exhibit_URL(exhibit)} alt={exhibit.ID}>
									</button>
								{/each}
							</div>
						</td>
					</tr>
				{/each}
			</tbody>
		</table>
		{#if !sections.length}
			<p class="empty">Das Abenteuer hat noch keine Abschnitte. Lege über die Leiste links eine Szene, eine Story oder eine Reise an.</p>
		{/if}
	</article>
</section>


<style lang="sass">
	@use "../colors" as colors

	.sections
		tbody tr
			cursor: pointer

		.grip
			width: 28px
			color: colors.$grey-50
			cursor: grab

		.num
			width: 32px
			color: colors.$grey-60
			font-variant-numeric: tabular-nums

		.typ
			width: 80px

		.name
			padding-block: 12px
			font-size: 15px

		.site
			width: 220px

		.npcs
			width: 180px

		.images
			width: 30%

	.tag.started
		opacity: 0.6

	.siteLink
		display: flex
		align-items: center
		gap: 10px
		margin: 0
		padding: 0
		border: 0
		background: none
		color: inherit
		font-size: 13px
		text-align: left
		cursor: pointer

		img
			flex: none
			width: 64px
			height: 42px
			object-fit: cover
			border-radius: 4px
			background: colors.$grey-20

		&:hover
			color: colors.$white
			text-decoration: underline colors.$primary-100

	.tokens, .thumbs
		display: flex
		flex-wrap: wrap
		gap: 4px

	.tokenBtn, .thumbBtn
		margin: 0
		padding: 0
		border: 0
		background: none
		cursor: pointer

	.tokenBtn
		border-radius: 50%

		.token
			width: 34px
			height: 34px

		&:hover .token
			border-color: colors.$primary-100

	.thumbBtn
		border-radius: 4px

	.thumb
		display: block
		width: 48px
		height: 48px
		object-fit: cover
		border-radius: 4px
		border: 1px solid transparent

		&:hover
			border-color: colors.$grey-85

		&.exhibited
			border-color: colors.$primary-100

</style>
